import { searchParametersActions } from 'features/searchResultsFacets';
import Select from '@components/select';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectPrimaryBedroom } from '../redux/selectors';

const select = document.querySelector('[data-primary-bedroom-filter]');
const primaryBedroom$ = new Select(select).getObservable();
const setValue = (value) => {
  select.value = value || 0;
};

primaryBedroom$.subscribe((value) => {
  store.dispatch(searchParametersActions.fetchPrimaryBedroom(value));
});

store$.pipe(map(selectPrimaryBedroom), distinctUntilChanged()).subscribe(setValue);
